import gql from 'graphql-tag'

export default gql`
mutation updateOffice ($id: Int!, $details: [OfficeDetailInput]) {
  updateOffice (id: $id, input: { details: $details }) {
    id
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/office/update.js